import { graphql } from "@/graphql/generated/gql";
import {
  ArchiveMunicipalPropertyMutation,
  ArchiveMunicipalPropertyMutationVariables,
} from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const ARCHIVE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT: TypedDocumentNode<
  ArchiveMunicipalPropertyMutation,
  ArchiveMunicipalPropertyMutationVariables
> = graphql(/* GraphQL */ `
  mutation ArchiveMunicipalProperty($id: ID!) {
    archiveMunicipalProperty(id: $id) { id archivedAt }
  }
`);
